import { useCallback } from "react";
import { FlowActions } from "../../stores/flowStore";
export const useTopupFlow = () => {
  return _temp;
};
function _temp(t0) {
  const {
    onBack
  } = t0 === undefined ? {} : t0;
  FlowActions.startFlow({
    type: "topup",
    onBack
  });
}